import { autoinject } from 'aurelia-framework';

@autoinject
export class AdminDashboard {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}